<script setup>
import { computed } from 'vue';

const props = defineProps({
    headers: {
        type: Array, // Array of { key: string, label: string, title?: string, class?: string, cellClass?: string, condition?: boolean, align?: string, standout?: boolean }
        required: true
    },
    items: {
        type: Array,
        required: true
    },
});

const visibleHeaders = computed(() => {
    return props.headers.filter(h => h.condition === undefined || h.condition);
});
</script>
<template>
    <div class="w-full">
        <div class="overflow-x-auto overflow-hidden rounded-md min-h-[450px] border">
            <template v-if="items && items.length">
                <table class="text-sm text-left rtl:text-right text-gray-700 table-auto min-w-full">
                <thead v-if="headers && headers.length" class="hidden lg:table-header-group text-sm text-gray-900 bg-gray-100 border-b sticky top-0 z-10">
                    <tr>
                        <th v-for="header in visibleHeaders" :key="header.key" :class="[header.class, 'lg:p-3']" :style="header.style" :title="header.title" class="text-center font-normal lg:font-semibold tracking-wider whitespace-nowrap">
                            <!-- Slot for header customization -->
                            <slot :name="`header-${header.key}`" :header="header">
                                <div v-if="header.rotate" style="writing-mode: vertical-rl; transform: rotate(180deg); margin: auto;">
                                    {{ header.label }}
                                </div>
                                <template v-else>
                                    {{ header.label }}
                                </template>
                            </slot>
                        </th>
                    </tr>
                </thead>
                <tr v-for="(item, index) in items" :key="item.id || index" class="max-w-full block relative border-b-4 border-gray-100 lg:table-row lg:border-b lg:hover:bg-gray-200/70 odd:lg:bg-gray-100/50">
                    <td v-for="header in visibleHeaders" :key="header.key" :data-label="header.label" :class="[header.cellClass, header.standout ? 'bg-gray-100 lg:bg-transparent font-semibold lg:font-normal before:font-semibold before:lg:font-normal' : '', 'flex justify-between text-right py-3 px-3 align-top border-b border-gray-100 lg:table-cell lg:p-3 lg:align-middle lg:border-b-0 text-sm [&:not(:first-child)]:lg:border-l [&:not(:first-child)]:lg:border-t-0 [&:not(:first-child)]:lg:border-r-0 [&:not(:first-child)]:lg:border-b-0 [&:not(:first-child)]:lg:border-gray-100 last:border-b-0 before:content-[attr(data-label)] before:pr-0 lg:before:pr-3 before:text-left lg:before:hidden before:text-[0.8rem] before:whitespace-nowrap lg:before:text-sm']">
                        <!-- Slot for cell customization -->
                        <div class="text-sm whitespace-nowrap w-full flex items-center gap-2" :class="[header.align === 'center' ? 'justify-end text-right lg:justify-center lg:text-center' : '', header.align === 'right' ? 'justify-end text-right' : header.align === 'between' ? 'justify-between' : 'justify-end text-right lg:justify-start lg:text-left']">
                            <slot :name="`cell-${header.key}`" :item="item" :index="index">
                                {{ item[header.key] }}
                            </slot>
                        </div>
                    </td>
                </tr>

                </table>
            </template>
            <div v-else class="flex flex-col items-center justify-center min-h-[300px]">
                <div class="text-gray-400 text-center p-5">
                    
                    <div class="text-sm">
                        <slot name="empty">
                            <p>No hay registros para mostrar</p>
                        </slot>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
